export default class Helper {
    constructor() {

    }
    static replaceSpace(str) {
        str = str.toString().replace( " ", "%20");
        return str;
    }
    static getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    }
    static addInfoText(text) {
        $(".info_message").show().html(text).delay(2000).fadeOut(4000);
    }
    static modal(title, content){

        $("#error_message").find("#modalTitle").html(title);
        $("#error_message").find(".modalContent").html(content);

        $('#error_message').foundation('open');

    }
};